// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import alarm from 'assets/audio/alarm.mp3';

// Services
import { registerSocket, deregisterSocket } from 'services/socket';
import Triage from 'services/data/triage';

// Actions
import { update } from 'modules/triage/store/actions';

// Components
import TriageItem from 'components/models/triage/triage-items';
import FlipMove from 'components/widgets/animation/flip-move';
import SVG from 'components/widgets/icons/svg';
import Clock from 'components/widgets/dates/clock';

// Constants
import { isMobile } from 'constants';

// Utils
import newTriageAlert from 'utils/new-triage-alert';


class TriageList extends React.Component {
  static propTypes = {
    items: PropTypes.array
  };

  componentDidMount() {
    registerSocket('triage', update);
  }

  componentDidUpdate(prevProps) {
    newTriageAlert(prevProps.items, this.props.items);
  }
  
  componentWillUnmount() {
    deregisterSocket('triage');
  }

  render() {
    const { items } = this.props;
    const sorted = _(items)
      // Sort the triage items
      .reject({ status: 'Archived' })
      .orderBy([Triage.getSortKey], ['desc'])
      .value();

    const duration = isMobile ? 200 : 500;

    return (
      <div className="triage-dashboard">
        <audio id="triage-audio" src={alarm} autoPlay={false} ></audio>
        <div className="clock-wrapper">
          <SVG src="svg/triage.svg" />
          <Clock format="h:mm A M/D" />
        </div>
        <FlipMove duration={duration}>
          {_.map(sorted, (item) =>
            <div key={item.triageId} >
              <TriageItem item={item} eagerUpdate={_.noop} onDashboard />
            </div>
          )}
        </FlipMove>
      </div>
    );
  }
}

// Exports
export default connect((state) => ({
  items: state.triage.items
}))(TriageList);



// WEBPACK FOOTER //
// ./app/routes/dashboards/triage.js